export default "__VITE_ASSET__6213a2e1__"